import { render, staticRenderFns } from "./Lokalis.vue?vue&type=template&id=fdaf89fa&scoped=true&"
import script from "./Lokalis.vue?vue&type=script&lang=ts&"
export * from "./Lokalis.vue?vue&type=script&lang=ts&"
import style0 from "./Lokalis.vue?vue&type=style&index=0&id=fdaf89fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdaf89fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VForm,VIcon,VRow})
